var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClaimEcoDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 21,
  viewBox: "0 0 22 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.255.286A.485.485 0 0 0 20.808 0C2.032 0 0 7.447 0 10.649c0 4.154 3.306 6.945 8.226 6.945 6.214 0 7.516-5.658 8.215-8.698.68-3.095 2.32-5.92 4.708-8.106a.448.448 0 0 0 .106-.504Z",
  fill: "#AFAFAF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M.484 20.373A.474.474 0 0 1 0 19.91C0 17.157 4.989 8.324 12.854 4.677a.494.494 0 0 1 .647.215.454.454 0 0 1-.225.619C5.334 9.193.968 17.746.968 19.91a.474.474 0 0 1-.484.463Z",
  fill: "#7B7B7B"
})));
export default SvgClaimEcoDark;